var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.hasSubscriptions ? _vm._l(_vm.subscriptionsGroups, function (subscriptionList, dateKey) {
    return _c('div', {
      key: dateKey
    }, [_c('div', {
      staticClass: "group-header"
    }, [_vm._v(" " + _vm._s(dateKey) + " ")]), _c('ul', {
      staticClass: "group-list"
    }, _vm._l(subscriptionList, function (subscription) {
      return _c('subscription-item', {
        key: "".concat(subscription.id, "_").concat(subscription.createdAt),
        attrs: {
          "subscription": subscription
        },
        on: {
          "click": _vm.onClickSubscription,
          "unfollow": function unfollow(id) {
            return _vm.$emit('unfollow', id);
          }
        }
      });
    }), 1)]);
  }) : _c('div', {
    staticClass: "subscription-empty-list"
  }, [_vm._v(" " + _vm._s(_vm.$t('no.subscriptions')) + " ")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }